<p>managepage works!</p>
